import {
  versionListConstants,
  versionUploadConstants,
} from "../_redux-constants/";

export function versionListReducer(
  state = {
    versionListLoading: false,
    versionListData: null,
    versionListError: null,
    versionUploadLoading: false,
    versionUploadData: null,
    versionUploadError: null,
  },
  action
) {
  switch (action.type) {
    case versionListConstants.VERSION_LIST_LOADING:
      return Object.assign({}, state, {
        versionListLoading: true,
        versionListError: null,
        versionListData: null,
      });
    case versionListConstants.VERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        versionListLoading: false,
        versionListData: action.data,
      });
    case versionListConstants.VERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        versionListLoading: false,
        versionListData: null,
        versionListError: action.error,
      });
    case versionUploadConstants.VERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        versionUploadLoading: true,
        versionUploadError: null,
        versionUploadData: null,
      });
    case versionUploadConstants.VERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        versionUploadLoading: false,
        versionUploadData: action.data,
      });
    case versionUploadConstants.VERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        versionUploadLoading: false,
        versionUploadData: null,
        versionUploadError: action.error,
      });
    default:
      return state;
  }
}
